module.exports = __webpack_public_path__ + "media/images/pic/brodno/brodno_news-a9a8b3cbae4c53dbee56c5d8b78a78ce.svg";